<script setup lang="ts">
import { useToast, TSIcon } from 'tsv2-library';

const toast = useToast();

const props = defineProps<{
  value: string;
}>();

/**
 * Handle the copy button to copy value to clipboard.
 */
const copyToClipboard = (): void => {
  navigator.clipboard.writeText(props.value);

  toast.add({
    message: 'Copied to clipboard',
    severity: 'info',
  });
};
</script>
<template>
  <TSIcon
    @click="copyToClipboard"
    class="text-general-400"
    data-ts-section="copy-button"
    icon="file-copy"
  />
</template>
